import { IOptionStringValue } from 'bricks/types';

 
export enum DealDocumentType {
    CAD_BIM = 'CAD/BIM',
    DRAWINGS_AMENDMENTS_BULLETINS = 'Drawings - Amendments/Bulletins',
    DRAWINGS_CONSTRUCTION_DOCUMENTS = 'Drawings - Construction Documents',
    DRAWINGS_DESIGN_DEVELOPMENT = 'Drawings - Design Development',
    DRAWINGS_FILING_SET = 'Drawings - Filing Set',
    DRAWINGS_SCHEMATIC_DESIGN = 'Drawings - Schematic Design',
    ENVIRONMENTAL_PHASE_I_ASSESSMENT = 'Environmental Phase I Assessment',
    ENVIRONMENTAL_PHASE_II_ASSESSMENT = 'Environmental Phase II Assessment',
    FFE = 'FF&E',
    FIELD_DAILY_REPORT = 'Field/Daily Report',
    FINANCIAL_PRO_FORMA = 'Financial Pro Forma',
    GEOTECHNICAL_REPORT = 'Geotechnical Report',
    JV_AGREEMENT = 'JV Agreement',
    LEASE_AGREEMENT = 'Lease Agreement',
    LEGAL = 'Legal',
    LOAN_FINANCING_AGREEMENT = 'Loan/Financing Agreement',
    MUNICIPAL_GOVERNMENT_DOCUMENTS = 'Municipal/Government Documents',
    OPERATIONS_MAINTENANCE_MANUAL = 'Operations & Maintenance Manual',
    OTHER = 'Other',
    PERMITS_ENTITLEMENTS = 'Permits/Entitlements',
    PROGRESS_PHOTOS = 'Progress Photos',
    PUNCH_LIST = 'Punch List',
    PURCHASE_AGREEMENT = 'Purchase Agreement',
    RENDERINGS = 'Renderings',
    RFI = 'RFI',
    SIGNAGE_WAYFINDING = 'Signage/Wayfinding',
    SUBMITTAL = 'Submittal',
    UTILITY_AGREEMENT = 'Utility Agreement',
    WARRANTY = 'Warranty',
}

export const DEAL_DOCUMENT_TYPE_OPTIONS : IOptionStringValue[] = Object.values(DealDocumentType).map(value => ({
    value,
    label: value,
}));

export enum ASSET_TAGS {
    FINANCIAL_PROFORMA = 'Financial Proforma',
    LOAN_FINANCING_AGREEMENT = 'Loan/Financing Agreement',
    JV_AGREEMENT = 'JV Agreement',
    PURCHASE_AGREEMENT = 'Purchase Agreement',
    ENV_PHASE_1 = 'Environmental Phase I Assessment',
    ENV_PHASE_2 = 'Environmental Phase II Assessment',
    PERMITS_ENTITLEMENTS = 'Permits/Entitlements',
    DRAWINGS_SCHEMATIC_DESIGN = 'Drawings - Schematic Design',
    DRAWINGS_DESIGN_DEV = 'Drawings - Design Development',
    DRAWINGS_FILING_SET = 'Drawings - Filing Set',
    DRAWINGS_CONSTRUCTION_DOCS = 'Drawings - Construction Documents',
    DRAWINGS_AMENDMENTS_BULLETINS = 'Drawings - Amendments/Bulletins',
    LEGAL = 'Legal',
    LEASE_AGREEMENT = 'Lease Agreement',
    CAD_BIM = 'CAD/BIM',
    RENDERINGS = 'Renderings',
    GEOTECHNICAL_REPORT = 'Geotechnical Report',
    FIELD_DAILY_REPORT = 'Field/Daily Report',
    RFI = 'RFI',
    FFE = 'FF&E',
    SIGNAGE_WAYFINDING = 'Signage/Wayfinding',
    PUNCH_LIST = 'Punch List',
    OPS_MAINTENANCE_MANUAL = 'Operations & Maintenance Manual',
    WARRANTIES = 'Warranties',
    MUNICIPAL_GOV_DOCS = 'Municipal/Government Documents',
    PROGRESS_PHOTOS = 'Progress Photos',
    OTHER = 'Other',
    SUBMITTAL = 'Submittal',
    UTILITY_AGREEMENT = 'Utility Agreement',
}

export const DOCUMENT_TYPE_OPTIONS = Object.values(DealDocumentType).map((value: string) => ({
    label: value,
    value,
}));

export enum DocumentLibraryColumn {
    NAME = 'Name',
    TYPE = 'Type',
    FORMAT = 'Format',
    DATE_MODIFIED = 'Date modified',
    SIZE = 'Size',
}

export const DOCUMENT_LIBRARY_COLUMNS = [
    DocumentLibraryColumn.NAME,
    DocumentLibraryColumn.TYPE,
    DocumentLibraryColumn.FORMAT,
    DocumentLibraryColumn.DATE_MODIFIED,
    DocumentLibraryColumn.SIZE,
];

export const DOCUMENT_LIBRARY_COLUMN_OPTIONS = DOCUMENT_LIBRARY_COLUMNS.map(column => ({
    label: column,
    value: column,
}));
